import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import Schedule from '@mui/icons-material/Schedule';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';
import { List } from '@mui/material';
import { isAdminEmail, useIsSuperAdmin, useUserEmail } from '../util/DataStore';

export const SideNavMenu = () => {
  const navigate = useNavigate();
  const [email] = useUserEmail();
  useIsSuperAdmin();
  const admin = isAdminEmail(email);

  return (
    <List>
      <ListItem button onClick={() => navigate('/sites')}>
        <ListItemIcon>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary="Sites" />
      </ListItem>

      {admin && (
        <ListItem button onClick={() => navigate('/users')}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
      )}

      <ListItem button onClick={() => navigate('/')}>
        <ListItemIcon>
          <Schedule />
        </ListItemIcon>
        <ListItemText primary="Schedule" />
      </ListItem>
    </List>
  );
};
